import { useTranslation } from "gatsby-plugin-react-i18next";
import type { FC } from "react";
import { Button } from "@babybjorn/ui";
import useScript from "../../hooks/use-script";

type BabylistProductDetails = {
	Title: string;
	ImageUrl: string;
	URL: string;
	Price: number;
	SKU: string;
	CurrencyCode: string;
	Color: string;
};

type MyRegistrySDKProps = BabylistProductDetails & {
	Quanity: number;
	HideSize: boolean;
	ReadOnlyPrice: boolean;
	IsAutoSaveGift: boolean;
	DefaultRegistryType: number;
};

type MyRegistrySDK = {
	new (productDetails: MyRegistrySDKProps): void;
	on: (event: string, callback: (e: unknown) => void) => void;
	setLang: (lang: string) => void;
	showPopup: () => void;
};

declare global {
	interface Window {
		MyRegistrySDK?: new (
			...args: ConstructorParameters<MyRegistrySDK>
		) => MyRegistrySDK;
	}
}

const MyRegistryButton: FC<BabylistProductDetails> = (productDetails) => {
	const { t } = useTranslation();

	useScript({
		script: {
			id: "myregistry_script",
			type: "text/javascript",
			src: `//www.myregistry.com/ScriptPlatform/API/AddButtonSDK.js?siteKey=XKQcrYiCb2TGWB0po17mMg2`,
			async: true,
		},
		removeOnUnmount: false,
	});

	const addToRegistry = () => {
		if (!window.MyRegistrySDK) return;

		const myRegistrySDK = new window.MyRegistrySDK({
			...productDetails,
			Quanity: 1,
			HideSize: true,
			ReadOnlyPrice: true,
			IsAutoSaveGift: true,
			DefaultRegistryType: 1, // 1 for Babylist,
		});
		myRegistrySDK.on("popup_showing", (e) => {
			console.log("popup_showing", e);
		});

		myRegistrySDK.setLang(
			process.env.GATSBY_LANGUAGE?.includes("fr") ? "fr" : "en",
		);
		myRegistrySDK.showPopup();
	};

	return (
		<Button
			onClick={() => addToRegistry()}
			variant="outline"
			size="always-small"
			className="font-semibold"
		>
			{`${t("Add to")} MyRegistry`}
		</Button>
	);
};

export default MyRegistryButton;
